import React, {Component} from "react";
import {Runtime, Inspector} from "@observablehq/runtime";
import notebook from "@namitmohale/enps-chart";
import ReactToPdf from 'react-to-pdf';

class EnpsChart extends Component {
    constructor(props){
        super(props);
        this.state = {
            // data: props.data,
            SCREEN_WIDTH: window.innerWidth
        }
    }

    animationRef = React.createRef();
    pdfRef = React.createRef();

    componentDidMount() {
        const runtime = new Runtime().module(notebook, name => {
          if (name === "chart") {
            return new Inspector(this.animationRef.current);
          }
        });
    }

    render() {
        return (
            <div style={{padding: 20}}>
                <div className="ui grid" ref={this.pdfRef} style={{display:'flex', flex:1}}>
                    {/* <div className="thirteen wide column" style={{}} ref={this.animationRef}></div> */}
                    <div className="twelve wide column" style={{display:'flex', flex:3/5, width: this.state.SCREEN_WIDTH*91/128,}}>
                        <div className="twelve wide column" style={{ width: this.state.SCREEN_WIDTH*91/128,}} ref={this.animationRef}></div>
                    </div>
                    <div className="four wide column" style={{ display:'flex', flex:1, flexDirection: 'column', justifyContent:'flex-start', paddingLeft: 5 }}>
                        <p>Note: Hover over the graph to see more details</p>
                        <p></p>
                        <p>Asking employees questions about recommending the company as a place to work, eNPS can help organizations shape their employee value proposition and improve their employer brand.
                            The organization can apply these concepts to build emotional connection, commitment, and loyalty among employees.
                        </p>
                        <p>
                            <span>eNPS score ranges from -100 to 100.</span>
                            <br />
                            <span>{`* >50 --> Excellent`}</span>
                            <br />
                            <span>{`* 10-30 --> Good`}</span>
                            <br />
                            <span>{`* 0 --> Equal Balance`}</span>
                            <br />
                            <span>{`* <-10 --> Bad`}</span>
                        </p>
                        <p>
                            <span>Response types:</span>
                            <br />
                            <span>{`* Detractors --> % responses with score 0-6`}</span>
                            <br />
                            <span>{`* Passives --> % responses with score 7-8`}</span>
                            <br />
                            <span>{`* Promotors --> % responses with score 9-10`}</span>
                        </p>
                        {/* {this.props.description.map((line, index) => {
                            return <p key={index} style={{ }}>{line}</p>
                        })} */}
                    </div>
                </div>
                <div className="row" style={{display:'flex', flex:1}}>
                    <ReactToPdf x={0} y={0} 
                                    targetRef={this.pdfRef} 
                                    filename="div-blue.pdf" 
                                    height='800' 
                                    options={{
                                        "orientation":'landscape', 
                                        "format":'a4', 
                                        margins : {
                                            top: 0,
                                            bottom: 0,
                                            left: 0,
                                            // height: 1000,
                                            // width: '100%'
                                        }
                                    }}
                        >
                        {({toPdf}) => (
                        <button onClick={toPdf}>Generate pdf</button>
                        )}
                    </ReactToPdf>
                </div>
            </div>
        );
    }
}

export default EnpsChart;